import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moment from 'moment'
import type { TFunction } from 'react-i18next'
import { Colored, Input } from '../../../components'
import type { Promo } from '../../../types'
import type { ExtendedPromo } from './Promos'
import PromoStatus from './PromoStatus'

interface TableDisplayParams {
    onSelectPromo: (id: number, isSelected: boolean) => void;
    selectedPromoId?: number;
    t: TFunction;
}

const tableDisplay = ({ onSelectPromo, selectedPromoId, t }: TableDisplayParams) => {
    const elements = [
        {
            onlyOnMobile: true,
            field: 'name',
            label: t('name'),
            props: { style: { textAlign: 'left' } },
            transform: null,
            width: '250px',
        },
        {
            onlyOnMobile: true,
            field: null,
            label: '',
            props: { align: 'center' },
            transform: ({ id, selected = false }: ExtendedPromo) => (
                <Input
                    onChange={(e: React.MouseEvent) => {
                        e.stopPropagation()
                        onSelectPromo(id, !selected)
                    }}
                    type="check"
                    value={selected}
                />
            ),
            width: '50px',
        },
        {
            onlyOnMobile: true,
            field: null,
            label: t('status'),
            props: { style: { textAlign: 'left' } },
            transform: (promo: Promo) => (
                <PromoStatus promo={promo} />
            ),
            width: '100px',
        },
        {
            onlyOnMobile: true,
            field: 'date_start',
            label: t('date-start'),
            props: { paddingLeft: '15px', textAlign: 'left' },
            transform: (dateStart: string) => (
                <>{moment(dateStart).format('DD/MM/YYYY')}</>
            ),
            width: '100px',
        },
        {
            field: null,
            label: '',
            props: null,
            transform: () => (
                <FontAwesomeIcon icon="chevron-right" />
            ),
            width: '20px',
        },
        {
            field: 'name',
            label: t('name'),
            props: null,
            transform: null,
            width: '250px',
        },
        {
            field: null,
            label: '',
            props: { align: 'center' },
            transform: ({ id, selected = false }: ExtendedPromo) => (
                <Input
                    onChange={(e: React.MouseEvent) => {
                        e.stopPropagation()
                        onSelectPromo(id, !selected)
                    }}
                    type="check"
                    value={selected}
                />
            ),
            width: '50px',
        },
        {
            field: null,
            label: t('status'),
            props: null,
            transform: (promo: Promo) => (
                <PromoStatus promo={promo} />
            ),
            width: '100px',
        },
        {
            field: 'date_start',
            label: t('date-start'),
            props: { paddingLeft: '15px' },
            transform: (dateStart: string) => (
                <>{moment(dateStart).format('DD/MM/YYYY')}</>
            ),
            width: '100px',
        },
        {
            field: 'date_end',
            label: t('date-end'),
            props: null,
            transform: (dateEnd: string) => (
                <>{moment(dateEnd).format('DD/MM/YYYY')}</>
            ),
            width: '100px',
        },
        {
            field: null,
            label: t('promo-priority'),
            props: { align: 'center' },
            transform: ({ priority, id }: ExtendedPromo) => (
                <Colored color={id === selectedPromoId ? 'white' : 'blue'}>{priority}</Colored>
            ),
            width: '50px',
        },
    ]

    return elements
}

export default tableDisplay
